import { render, staticRenderFns } from "./UserAvatarList.vue?vue&type=template&id=2ce69c0f&scoped=true&"
import script from "./UserAvatarList.vue?vue&type=script&lang=js&"
export * from "./UserAvatarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce69c0f",
  null
  
)

export default component.exports